import './sp-taxon-input-dialog';

import {css, html} from 'lit';
import {customElement, property, query} from 'lit/decorators.js';
import {translate} from '@stefanholzapfel/lit-translate';
import {classMap} from 'lit-html/directives/class-map.js';
import {styleMap} from 'lit-html/directives/style-map.js';
import {when} from "lit/directives/when.js";
import {SpBaseInput} from "../sp-base-input";
import {SpDefaultDialog} from "../../sp-dialog/sp-default-dialog";
import {unsafeCSSIcon} from "../../../styles/icons";

@customElement('sp-taxon-input')
export class SpTaxonInput extends SpBaseInput<SpUiTaxon> {
    static styles = [
        //language=CSS
        css`
            :host {
                position: relative;
                display: block;
            }
            .select-label {
                white-space: nowrap;
                display: block;
                position: relative;
                width: 100%;
                height: 45px;
                box-sizing: border-box;
                box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);
                background-image: url(${ unsafeCSSIcon('ellipsis-h-square', { color: 'white', size: 'x128' }) });
                background-repeat: no-repeat;
                background-position: right 23px center;
                background-size: 24px auto;
                border-radius: 3px;
                overflow: hidden;
                cursor: pointer;
            }

            .select-label div {
                display: block;
                position: absolute;
                left: 0;
                right: 70px;
                background-color: #fff;
                height: 45px;
                box-sizing: border-box;
                font-size: 14px;
                line-height: 45px;
                padding: 0 10px;
                overflow: hidden;
            }

            .select-reset {
                position: absolute;
                top: 1px;
                right: 70px;
                width: 45px;
                height: 43px;
                background-image: url(${ unsafeCSSIcon('close', { color: 'grey-light', size: 'x128' }) });
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 1rem auto;
                background-color: #fff;
                cursor: pointer;
            }

            .placeholder {
                color: #aaa;
            }

            .active {
                color: #000;
            }

            .disabled {
                color: #aaa;
            }`
    ];
    @property({ type: Object })
    value;
    @property({ type: Boolean })
    valueLoading;
    @property({ type: Array })
    taxonList: SpUiTaxon[];
    @property({ type: Boolean })
    taxonListLoading = false;
    @property({ type: Boolean, reflect: true })
    disabled = false;
    @property({ type: Boolean })
    required = false;
    @property({ type: String })
    label;

    @query('sp-default-dialog')
    dialog: SpDefaultDialog;

    render() {
        return html`
            <sp-default-dialog
                .defaultClearContentOnHide=${false}
                .template=${
                    html`<sp-taxon-input-dialog
                            .value=${ this.value }
                            .changeCallback=${ this.emitChangeFromDialog.bind(this) }
                            .queryChangeCallback=${ query => {
                                this.emitChangeSearchQuery(query)
                            }}
                            .taxonList=${this.taxonList}
                            .taxonListLoading=${this.taxonListLoading}>
                        </sp-taxon-input-dialog>`
                }
                .suppressBodyScrollbar=${ true }
                .fullHeight=${ true }
                .headerText=${ this.label }>
            </sp-default-dialog>
            <div
                @click=${ this.openModal }
                class=${ classMap({
                    'select-label': true,
                    disabled: this.disabled,
                    active: this.value && !this.disabled,
                    placeholder: !this.value && !this.disabled
                })}
                style=${
                    styleMap({
                        'background-color': this.disabled ? 'rgb(var(--sp-color-d))' : 'rgb(var(--sp-color-b))'
                    })
                }>
                <div>${ this.value ? !this.value ? translate('LOADING') : this.value.label : this.label }</div>
            </div>
            ${ when(!this.required && !this.disabled && this.value, () => 
                    html`<div class="select-reset" @click=${ this.reset }></div>`) }
        `;
    }

    reset() {
        this.value = null;
        this.emit('change', null);
    }

    emitChangeFromDialog(taxon: SpUiTaxon) {
        this.value = taxon;
        this.emit<SpTaxonInputChangeEventPayload>('change', { detail: { value: taxon } });
    }

    emitChangeSearchQuery(query: string) {
        this.emit<SpTaxonInputQueryChangeEventPayload>('change-query', { detail: { value: query } });
    }

    async openModal() {
        if (!this.disabled) {
            this.dialog.show();
        }
    }

}

export interface SpUiTaxon {
    id: string;
    taxon_name?: string;
    label?: string;
    lang?: string;
    wikipedia?: string;
    image?: string;
    caption?: string;
}

export interface SpTaxonInputChangeEventPayload {
    value: SpUiTaxon
}

export interface SpTaxonInputQueryChangeEventPayload {
    value: string
}